// services/menteeRegistrationForm.services.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl } from '../../services/api';

export const menteeRegistrationFormSlice = createApi({
  reducerPath: 'menteeRegistrationForm',

  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl, // Adjust based on your API base URL
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem('access_token');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['menteeRegistrationForm'],
  endpoints: (builder) => ({
    registerMentee: builder.mutation({
      query: (formData) => ({
        url: 'mentee-registration/',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['menteeRegistrationForm'],
    }),

    editMentee: builder.mutation({
      query: ({ id, formData,params }) => ({
           url: `mentee-registration/${id}/?${params}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: ['menteeRegistrationForm'],
    }),
    getmenteeRegistrationFormDetailsbyId: builder.query({
      query: (id) => `mentee-registration/${id}/user/`,
      providesTags: ['menteeRegistrationForm'],
    }),
    getmenteeRegistrationFormDetails: builder.query({
      query: () => 'mentee-registration/',
      providesTags: ['menteeRegistrationForm'],
    }),

    getmenteeRegistrationFormStatus: builder.query({
      query: (id) => `onboarding-status/${id}/`,
      providesTags: ['menteeRegistrationForm'],
    }),

    getInterestTraits: builder.query({
      query: () => `interest-traits/`,
      providesTags: ['menteeRegistrationForm'],
    }),

    getEthnicities: builder.query({
      query: () => `ethnicities/`,
      providesTags: ['menteeRegistrationForm'],
    }),

    getEthnicitiesbySlug: builder.query({
      query: (body) => ({
        url: 'ethnicities/',
        method: 'POST',
        body,
      }),
      providesTags: ['menteeRegistrationForm'],
    }),

    getLanguages: builder.query({
      query: () => `languages/`,
      providesTags: ['menteeRegistrationForm'],
    }),

    getRelationships: builder.query({
      query: () => `relationship/`,
      providesTags: ['menteeRegistrationForm'],
    }),

    getCommunicationMethods: builder.query({
      query: () => `communitcation-method/`,
      providesTags: ['menteeRegistrationForm'],
    }),
    getGenders: builder.query({
      query: () => `genders/`,
      providesTags: ['menteeRegistrationForm'],
    }),
    getChildCategories: builder.query({
      query: () => `child-categories/`,
      providesTags: ['menteeRegistrationForm'],
    }),
    getIntrestTraits: builder.query({
      query: () => `interest-traits/`,
      providesTags: ['menteeRegistrationForm'],
    }),
  }),
});

export const {
  useRegisterMenteeMutation,
  useGetmenteeRegistrationFormStatusQuery,
  useGetmenteeRegistrationFormDetailsQuery,
  useEditMenteeMutation,
  useGetInterestTraitsQuery,
  useGetEthnicitiesQuery,
  useGetEthnicitiesbySlugQuery,
  useGetmenteeRegistrationFormDetailsbyIdQuery,
  useGetLanguagesQuery,
  useGetRelationshipsQuery,
  useGetCommunicationMethodsQuery,
  useGetGendersQuery,
  useGetChildCategoriesQuery,
  useGetIntrestTraitsQuery
} = menteeRegistrationFormSlice;

export default menteeRegistrationFormSlice;
